class ElementScheduler extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.disabledDays = this.getAttribute('days-to-hide').split(',')

    const date = new Date()
    this.today = date.getDay()

    if (this.disabledDays.includes(this.today.toString())) {
      this.setAttribute('hidden', '')
    }
  }
}

if (!customElements.get('element-scheduler')) {
  customElements.define('element-scheduler', ElementScheduler)
}
